import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa'; // Import the left arrow icon

function ManageRooms() {
  const tabClass =
    'px-10 py-2 text-base font-medium border-b-2 border-transparent hover:border-black transition-all ';
  const activeClass = ' text-white bg-black';

  return (
    <div className="mb-4">
      <NavLink
        to="/dashboard/core-modules/property-management-system/front-desk-operations"
        className="flex items-center text-gray-400 hover:text-black mb-4"
      >
        <FaArrowLeft className="mr-3 text-md" /> {/* Left arrow icon */}
        <span className="text-lg">Back to Front Desk Operations</span>
      </NavLink>

      {/* Tabs container */}
      <div className="flex  ">
        <NavLink
          to="/dashboard/core-modules/property-management-system/front-desk-operations/reschedule"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-gray-100'}`
          }
        >
          Reschedule
        </NavLink>
        <NavLink
          to="/dashboard/core-modules/property-management-system/front-desk-operations/room-upgrade"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-gray-100'}`
          }
        >
          Room upgrade
        </NavLink>
      </div>
    </div>
  );
}

export default ManageRooms;
